import api from '../api/axios.config';

export const reportsService = {
  getReports: async () => {
    try {
      const response = await api.get(`/reports/list`);
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },
  
  deleteReportById: async (reportId) => {
    try {
      const response = await api.delete(`/reports/${reportId}`);

      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  createReport: async (reportData) => {
    try {
      const response = await api.post(
        `/reports/`,
        reportData
      );
      
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  previewReport: async (report_id, reportData) => {
    try {
      const response = await api.post(
        `/reports/preview/?report_id=${report_id}`,
        reportData
      );
      
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getNewReport: async () => {
    try {
      const response = await api.get(`/reports/new`);
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getReportById: async (reportId, filters) => {
    try {
      const params = filters;
  
      const response = await api.get(`/reports/${reportId}`, { params });

      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getOverrideReportById: async (reportId, filters) => {
    try {
      const params = filters;
      if (reportId) params.report_id = reportId;
  
      const response = await api.get(`/reports/override`, { params });

      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  downloadExcel: async (reportId, filters) => {
    try {
      const response = await api.get(`/reports/${reportId}/download`, {
        params: filters,
        responseType: "blob",
      });
      return response;
    }
    catch (error) {
      throw error;
    }
  },

  updateReport: async (reportId, filters, updatedReportData) => {
    try{
      const response = await api.patch(
          `/reports/${reportId}`,
          updatedReportData,
          {
            params: filters
          }
      );

      return response.data;
    }
    catch(error){
      throw error
    }
  },

  getPromoActivities: async (filters) => {
    try {
      const response = await api.get(`/reports/promo-activities/`, {
        params: filters,
      });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  createPromoActivity: async (viewType, promoActivityData) => {
    try {
      const response = await api.post(
        `/reports/promo-activities/`,
        promoActivityData,
        {
          params: { view_type: viewType },
        }
      );

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  updatePromoActivity: async (promoId, promoActivityData) => {
    try {
      const response = await api.patch(
        `/reports/promo-activities/${promoId}`,
        promoActivityData
      );

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  previewPromoActivity: async (viewType, promoActivityParams) => {
    try {
      const response = await api.get(`/reports/promo-activities/preview`, {
        params: { view_type: viewType, ...promoActivityParams },
      });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },
};
